import api from "./base-api"

const cmSyncConflictsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getSyncConflictsCM: build.query({
            query: ({ stateId, vendorId, page = 0, limit = 25 }) => {
                const p = new URLSearchParams({ page, limit })
                if (stateId && stateId.trim()) p.set("stateId", stateId.trim())
                if (vendorId && vendorId.trim()) p.set("vendorId", vendorId.trim())
                return `v3/cm/sync-conflicts?${p.toString()}`
            },
            providesTags: ["SyncConflictsCM"]
        }),
        getSyncConflictCM: build.query({
            query: (id) => `v3/cm/sync-conflicts/${id}`,
            providesTags: (_r, _e, id) => [{ type: "SyncConflictsCM", id }]
        })
    }),
    overrideExisting: false
})

export const {
    useGetSyncConflictsCMQuery,
    useGetSyncConflictCMQuery
} = cmSyncConflictsApi
